import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { salaryDraftForwarded } from "store/actions/salaryDraftActions";
//#endregion
//#region types
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { AuthEnums, DialogEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { SalaryDraftMoreActionProps } from "models/propTypes/salaryPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { MoreActions } from "components/common";
import SalaryDraftForwardFormContainer from "./forms/forwardFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { CompanyService } from "services";

const SalaryDraftMoreActions: React.FC<SalaryDraftMoreActionProps> = (props) => {
  const { salaryDraft, markAsDone, onError, disableSuccessMessages } = props;

  const dispatch = useDispatch();

  //#region assign
  const onAssignSuccess = () => {
    markAsDone && markAsDone();
    dispatch(salaryDraftForwarded(salaryDraft.id));
  };

  const assignAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Assign),
    icon: IconDefinitionConstants.WForward,
    actionDialog: {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Assign),
      titleIcon: IconDefinitionConstants.WForward,
      dialogType: DialogEnums.DialogType.Content,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Return),
          successMessage: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Salary.SalaryDraftAssignSuccessMessage
          ),
        },
      ],
      children: <SalaryDraftForwardFormContainer salaryDraftId={salaryDraft.id} />,
      maxWidth: "sm",
      onError: onError,
      onSubmit: onAssignSuccess,
    },
  };

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];

    const isAuditor = CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.Auditor);

    if (salaryDraft.state === WintSuperkollAPIModel.SalaryDraftState.AtCustomer && !isAuditor) {
      actions.push(assignAction);
    }
    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} disableSuccessMessages={disableSuccessMessages} />;
};

export default SalaryDraftMoreActions;
